import { NotificationService } from './../../../../Services/notification.service';
import { NgFor, NgIf } from '@angular/common';
import { RateListGeneratorService } from './../../../../Services/Rate_List_Generator/rate-list-generator.service';
import { group } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { CustomSelectComponent } from '../../../Core/custom-select/custom-select.component';
import { RouterLink } from '@angular/router';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { Router } from '@angular/router';
import { CategoryService } from '../../../../Services/Category/category.service';
import { forkJoin } from 'rxjs';
import { Validators } from '@angular/forms';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const minLessThanMaxValidator: ValidatorFn = (
  formGroup: AbstractControl
): ValidationErrors | null => {

  const unit = formGroup.get('rlg_unit')?.value;

  // ⭐ Only validate when unit is By Gram
  if (unit !== 'By Gram') {
    return null;
  }

  const min = formGroup.get('rlg_min_weight_range')?.value;
  const max = formGroup.get('rlg_max_weight_range')?.value;

  if (min !== null && max !== null && min !== '' && max !== '') {
    if (+min >= +max) {
      return { minGreaterThanMax: true };
    }
  }

  return null;
};
@Component({
  selector: 'app-rate-list-generator',
  standalone: true,
  imports: [CustomSelectComponent, NgFor, ReactiveFormsModule, NgIf, RouterLink],
  templateUrl: './rate-list-generator.component.html',
  styleUrl: './rate-list-generator.component.css',
})
export class RateListGeneratorComponent implements OnInit {
  rateListGeneratorForm!: FormGroup;
  firmSelectionSubscription: any;
  currentFirmId: any;
  RateListGeneratorList: any;
  editButton: boolean = false;
  addbutton: boolean = true;
  showBelow: boolean = true;
  showAbove: boolean = true;
  minRange: boolean = true;
  maxRange: boolean = true;
  rateId: any;
  categories: any[] = [];

  //
  rateList: any[] = [];

  constructor(
    private fb: FormBuilder,
    private firmSelectionService: FirmSelectionService,
    private rateListGeneratorService: RateListGeneratorService,
    private NotificationService: NotificationService,
    private router: Router,
    private categoryService: CategoryService
  ) { }

  ngOnInit() {
    this.firmSelectionSubscription = this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      this.currentFirmId = firm?.id;
      this.initRateListGeneratorForm();
      // this.getRateList();
      this.getCategories();
      this.rateListGeneratorForm
        .get('rlg_customer_type')
        ?.valueChanges.subscribe((value) => {
          if (value) {
            this.selectedCustomer = value;
            this.rateListGeneratorForm
              .get('rlg_customer_type')
              ?.disable({ emitEvent: false });
          }
        });
    });
  }

  private isRangeOverlap(
    category: string,
    min: number,
    max: number,
    above: boolean,
    below: boolean,
    code: string
  ): boolean {
    const existing = this.RateListGeneratorList.filter(
      (x: any) => x.rlg_product_category === category
    );

    for (const item of existing) {
      // ✅ Skip check if it's a different code
      if (item.rlg_code !== code) continue;

      const itemMin = +item.rlg_min_weight_range;
      const itemMax = +item.rlg_max_weight_range;
      const itemAbove = item.rlg_above === 'Yes';
      const itemBelow = item.rlg_below === 'Yes';

      if (above && itemAbove) {
        return true;
      }
      if (below && itemBelow) {
        return true;
      }
      if (!above && !below && !itemAbove && !itemBelow) {
        if (
          (min >= itemMin && min <= itemMax) ||
          (max >= itemMin && max <= itemMax) ||
          (itemMin >= min && itemMin <= max)
        ) {
          return true;
        }
      }
    }

    return false;
  }
  getCategories() {
    forkJoin({
      rateList: this.rateListGeneratorService.getRateList(),
      categories: this.categoryService.getCategories(),
    }).subscribe(({ rateList, categories }: any) => {
      this.RateListGeneratorList = rateList.data.slice(-5).reverse();

      // store full categories for later lookup
      this.categories = categories.data;

      // store only names for dropdown
      this.prodCategory = this.categories
        .filter((item: any) => item.mrp && item.mrp !== '')
        .map((item: any) => ({
          label: item.name,
          value: item.id,
          subtype: item.SubType
        }));
    });
  }

  filterCategoriesByType(type: string) {
    if (!this.categories) return;

    this.prodCategory = this.categories
      .filter((item: any) => item.Type === type)    // <--- IMPORTANT
      .map((item: any) => ({
        label: item.name,
        value: item.id,
        subtype: item.SubType
      }));

    // reset category if invalid after filtering
    if (!this.prodCategory.includes(this.selectedProdCategory)) {
      this.selectedProdCategory = '';
      this.rateListGeneratorForm.patchValue({ rlg_product_category: '' });
    }
  }


  // onCategoryChange(categoryName: string) {
  //   const selectedCategory = this.categories.find(c => c.name === categoryName);

  //   if (selectedCategory) {
  //     // Patch the reactive form
  //     this.rateListGeneratorForm.patchValue({
  //       rlg_unit: selectedCategory.unit
  //     });

  //     // Update the custom select — make sure it's the exact value in options
  //     this.selectedUnit = this.unitType.find(u => u === selectedCategory.unit) || selectedCategory.unit;
  //   }
  // }
  onCategoryChange(categoryId: string) {

  const selectedCategory = this.categories.find(
    c => String(c.id) === String(categoryId)
  );

  if (!selectedCategory) return;

  const unit = selectedCategory.unit;

  const codeCtrl = this.rateListGeneratorForm.get('rlg_code');
  const rangeCtrl = this.rateListGeneratorForm.get('rlg_weight_range');
  const minCtrl = this.rateListGeneratorForm.get('rlg_min_weight_range');
  const maxCtrl = this.rateListGeneratorForm.get('rlg_max_weight_range');
  const labourCtrl = this.rateListGeneratorForm.get('rlg_per_gm_labour');
  const discountCtrl = this.rateListGeneratorForm.get('rlg_discount');
  const purityCtrl = this.rateListGeneratorForm.get('rlg_purity');

  /* ⭐ RESET ALL VALUES FIRST */
  codeCtrl?.setValue('');
  rangeCtrl?.setValue('');
  minCtrl?.setValue('');
  maxCtrl?.setValue('');
  labourCtrl?.setValue('');
  discountCtrl?.setValue('');
  purityCtrl?.setValue('');

  /* CLEAR OLD VALIDATORS */
  codeCtrl?.clearValidators();
  rangeCtrl?.clearValidators();
  minCtrl?.clearValidators();
  maxCtrl?.clearValidators();
  labourCtrl?.clearValidators();
  discountCtrl?.clearValidators();
  purityCtrl?.clearValidators();

  /* APPLY NEW VALIDATORS */

  if (unit === 'By Gram') {

    codeCtrl?.setValidators([Validators.required]);
    rangeCtrl?.setValidators([Validators.required]);
    minCtrl?.setValidators([Validators.required, Validators.min(0)]);
    maxCtrl?.setValidators([Validators.required, Validators.min(0)]);
    labourCtrl?.setValidators([Validators.required, Validators.min(1)]);

  }

  if (unit === 'By MRP') {

    discountCtrl?.setValidators([Validators.required, Validators.min(1)]);

  }

  if (unit === 'By Silver Rate') {

    purityCtrl?.setValidators([Validators.required, Validators.min(1)]);

  }

  /* ⭐ UPDATE VALIDITY */

  codeCtrl?.updateValueAndValidity();
  rangeCtrl?.updateValueAndValidity();
  minCtrl?.updateValueAndValidity();
  maxCtrl?.updateValueAndValidity();
  labourCtrl?.updateValueAndValidity();
  discountCtrl?.updateValueAndValidity();
  purityCtrl?.updateValueAndValidity();

  /* FORCE SET UNIT */

  this.rateListGeneratorForm.patchValue({
    rlg_unit: selectedCategory.unit
  }, { emitEvent: false });

  this.selectedUnit = selectedCategory.unit;
}

  prodCategory: any;
  selectedProdCategory: string = '';

initRateListGeneratorForm() {

  this.rateListGeneratorForm = this.fb.group(
  {
    rlg_customer_type: ['', Validators.required],
    rlg_department: [''],
    rlg_unit: [''],

    rlg_code: [''],

    rlg_weight_range: [''],
    rlg_min_weight_range: [''],
    rlg_max_weight_range: [''],

    rlg_per_gm_labour: [''],
    rlg_discount: [''],
    rlg_purity: [''],

    rlg_firm_id: this.currentFirmId,

    rlg_product_type: ['', Validators.required],
    rlg_product_category: ['', Validators.required],

    rlg_making_charges: ['', Validators.min(0)],

    rlg_above: [false],
    rlg_below: [false]
  },
  {
    validators: minLessThanMaxValidator
  });

  /* CUSTOMER TYPE LOCK */
  this.rateListGeneratorForm.get('rlg_customer_type')?.enable({ emitEvent: false });

  this.rateListGeneratorForm.get('rlg_customer_type')?.valueChanges.subscribe((value) => {
    if (value) {
      this.selectedCustomer = value;
      this.rateListGeneratorForm.get('rlg_customer_type')?.disable({ emitEvent: false });
    }
  });

  /* PRODUCT TYPE FILTER */
  this.rateListGeneratorForm.get('rlg_product_type')?.valueChanges.subscribe(type => {
    if (type) {
      this.filterCategoriesByType(type);
    }
  });

  /* WEIGHT RANGE LOGIC */
  this.rateListGeneratorForm.get('rlg_weight_range')?.valueChanges.subscribe((value) => {

    const unit = this.rateListGeneratorForm.get('rlg_unit')?.value;

    const minCtrl = this.rateListGeneratorForm.get('rlg_min_weight_range');
    const maxCtrl = this.rateListGeneratorForm.get('rlg_max_weight_range');

    const aboveCtrl = this.rateListGeneratorForm.get('rlg_above');
    const belowCtrl = this.rateListGeneratorForm.get('rlg_below');

    /* ⭐ IMPORTANT FIX */
    if (unit !== 'By Gram') {

      minCtrl?.clearValidators();
      maxCtrl?.clearValidators();

      minCtrl?.updateValueAndValidity();
      maxCtrl?.updateValueAndValidity();

      return;
    }

    if (value === 'All') {

      this.maxRange = false;
      this.minRange = false;

      minCtrl?.clearValidators();
      maxCtrl?.clearValidators();

      minCtrl?.setValue('');
      maxCtrl?.setValue('');

      minCtrl?.updateValueAndValidity();
      maxCtrl?.updateValueAndValidity();

      aboveCtrl?.setValue(true, { emitEvent: false });
      belowCtrl?.setValue(true, { emitEvent: false });

      aboveCtrl?.disable({ emitEvent: false });
      belowCtrl?.disable({ emitEvent: false });

    } else {

      this.maxRange = true;
      this.minRange = true;

      minCtrl?.setValidators([Validators.required, Validators.min(0)]);
      maxCtrl?.setValidators([Validators.required, Validators.min(0)]);

      minCtrl?.updateValueAndValidity();
      maxCtrl?.updateValueAndValidity();

      aboveCtrl?.enable({ emitEvent: false });
      belowCtrl?.enable({ emitEvent: false });

      aboveCtrl?.setValue(false, { emitEvent: false });
      belowCtrl?.setValue(false, { emitEvent: false });
    }
  });

  /* CATEGORY CHANGE */
  this.rateListGeneratorForm.get('rlg_product_category')?.valueChanges.subscribe((categoryId: string) => {
    if (categoryId) {
      this.onCategoryChange(categoryId);
    }
  });

  /* MIN RANGE LOGIC */
  this.rateListGeneratorForm.get('rlg_min_weight_range')?.valueChanges.subscribe((res: any) => {

    if (res !== null && res !== '') {
      this.showBelow = false;
      this.rateListGeneratorForm.get('rlg_below')?.setValue(false, { emitEvent: false });
    } else {
      this.showBelow = true;
    }

  });

  /* BELOW CHECKBOX */
  this.rateListGeneratorForm.get('rlg_below')?.valueChanges.subscribe((res: any) => {

    if (res === true) {
      this.minRange = false;
      this.rateListGeneratorForm.get('rlg_min_weight_range')?.setValue('', { emitEvent: false });
    } else {
      this.minRange = true;
    }

  });

  /* MAX RANGE LOGIC */
  this.rateListGeneratorForm.get('rlg_max_weight_range')?.valueChanges.subscribe((res: any) => {

    if (res !== null && res !== '') {
      this.showAbove = false;
      this.rateListGeneratorForm.get('rlg_above')?.setValue(false, { emitEvent: false });
    } else {
      this.showAbove = true;
    }

  });

  /* ABOVE CHECKBOX */
  this.rateListGeneratorForm.get('rlg_above')?.valueChanges.subscribe((res: any) => {

    if (res === true) {
      this.maxRange = false;
      this.rateListGeneratorForm.get('rlg_max_weight_range')?.setValue('', { emitEvent: false });
    } else {
      this.maxRange = true;
    }

  });

}

  onSubmit() {
     console.log("FORM VALUE:", this.rateListGeneratorForm.getRawValue());
  console.log("FORM VALID:", this.rateListGeneratorForm.valid);
  console.log("FORM ERRORS:", this.rateListGeneratorForm.errors);

  Object.keys(this.rateListGeneratorForm.controls).forEach(key => {
    const controlErrors = this.rateListGeneratorForm.get(key)?.errors;
    if (controlErrors) {
      console.log("CONTROL ERROR →", key, controlErrors);
    }
  });

  this.rateListGeneratorForm.markAllAsTouched();

  if (this.rateListGeneratorForm.invalid) {
    this.NotificationService.showError(
      'Please fill all required fields',
      'Validation Error'
    );
    return;
  }
    const formData = this.rateListGeneratorForm.getRawValue();

    // ✅ Sanitization: Strictly enforce mutual exclusion in the payload
    if (formData.rlg_below === true) formData.rlg_min_weight_range = null;
    if (formData.rlg_above === true) formData.rlg_max_weight_range = null;

    formData.rlg_above = formData.rlg_above ? 'Yes' : 'No';
    formData.rlg_below = formData.rlg_below ? 'Yes' : 'No';

    const min = +formData.rlg_min_weight_range;
    const max = +formData.rlg_max_weight_range;
    const above = formData.rlg_above === 'Yes';
    const below = formData.rlg_below === 'Yes';
    const category = formData.rlg_product_category;
    const code = formData.rlg_code;

    if (this.isRangeOverlap(category, min, max, above, below, code)) {
      this.NotificationService.showError(
        `Range already exists for code "${code}" in category "${category}"`,
        'Validation Error'
      );
      return;
    }

    this.rateListGeneratorService.createRateList(formData).subscribe({
      next: (res: any) => {
        this.NotificationService.showSuccess(
          'Rate List added successfully!',
          'Success'
        );

        this.rateId = res.data.rlg_id;
        this.getCategories();
        this.clearForm();
      },
      error: () => {
        this.NotificationService.showError('Something went wrong', 'Error');
        alert("Rate already set for same category and unit");
      },
    });
  }


  onDelete(rlg_id: any) {
    this.rateListGeneratorService.deleteRateList(rlg_id).subscribe(
      (res: any) => {
        this.NotificationService.showSuccess(
          'Rate Deleted Successfully',
          'Success'
        );
        this.getCategories();
      },
      (error: any) => {
        this.NotificationService.showError('Error deleting rate', 'Error');
      }
    );
  }

  patchRateListGenerator(rlg_id: any) {
    this.rateListGeneratorService
      .getRateListById(rlg_id)
      .subscribe((res: any) => {
        const data = res.data;
        this.rateId = data.rlg_id;

        // ✅ Sync UI visibility variables based on loaded data
        const isAbove = data.rlg_above === 'Yes';
        const isBelow = data.rlg_below === 'Yes';

        // Visibility flags for UI
        this.minRange = !isBelow;
        this.maxRange = !isAbove;
        this.showBelow = !data.rlg_min_weight_range;
        this.showAbove = !data.rlg_max_weight_range;

        // Frontend Cleanup: Nullify numeric fields if toggle is active during patch
        const patchedData = {
          ...data,
          rlg_above: isAbove,
          rlg_below: isBelow,
          rlg_min_weight_range: isBelow ? '' : data.rlg_min_weight_range,
          rlg_max_weight_range: isAbove ? '' : data.rlg_max_weight_range
        };

        this.rateListGeneratorForm.patchValue(patchedData);
        this.editButton = true;
        this.addbutton = false;
      });
  }

  updateForm() {

    if (this.rateListGeneratorForm.invalid) return;

    const formData = this.rateListGeneratorForm.getRawValue(); // ✅ includes disabled

    // ✅ Payload Sanitization: Prevent overriding by nullifying conflicting range values
    if (formData.rlg_below === true) formData.rlg_min_weight_range = null;
    if (formData.rlg_above === true) formData.rlg_max_weight_range = null;

    // Convert booleans like in create
    formData.rlg_above = formData.rlg_above ? 'Yes' : 'No';
    formData.rlg_below = formData.rlg_below ? 'Yes' : 'No';

    console.log("called before update");

    this.rateListGeneratorService
      .updateRateList(this.rateId, formData)
      .subscribe(
        (res: any) => {
          this.NotificationService.showSuccess(
            'Rate List Updated Successfully',
            'Success'
          );
          console.log("called after update");
          this.getCategories(); // ✅ reload list properly
          this.clearForm();
        },
        (error: any) => {
          this.NotificationService.showError(
            'Error updating rate list',
            'Error'
          );
        }
      );
  }

  clearForm() {
    this.rateListGeneratorForm.reset({
      rlg_firm_id: this.currentFirmId,
      rlg_product_type: '',
      rlg_customer_type:
        this.rateListGeneratorForm.get('rlg_customer_type')?.value,
    });
    this.editButton = false;
    this.addbutton = true;
    this.showBelow = true;
    this.showAbove = true;
    this.minRange = true;
    this.maxRange = true;
    this.NotificationService.showInfo('Form cleared', 'Info');
  }

  focusNext(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key === 'Enter') {
      keyboardEvent.preventDefault();

      const target = keyboardEvent.target as HTMLElement;
      const form = target.closest('form');
      if (!form) return;

      const focusable = Array.from(
        form.querySelectorAll<HTMLElement>('input, select, textarea, button')
      ).filter((el) => !el.hasAttribute('disabled') && el.tabIndex !== -1);

      const index = focusable.indexOf(target);
      if (index > -1 && index + 1 < focusable.length) {
        focusable[index + 1].focus();
      }
    }
  }

  // for Customer Type
  customerType: string[] = ['Wholesale', 'Jeweller', 'Direct'];
  selectedCustomer: string = '';

  // for Product Type
  productType: string[] = ['Assembly', 'Master'];
  selectedProduct: string = '';

  // for Product Category
  productCategory: string[] = [''];
  selectedCategory: string = '';

  // for Product Categoryate
  unitType: string[] = ['By Gram', 'By MRP', 'By Silver Rate'];
  selectedUnit: string = '';

  // for Weight Range
  wtRange: string[] = ['Custom', 'All'];
  selectedRange: string = '';

  onSaveListClick() {
    this.rateListGeneratorForm.get('rlg_customer_type')?.enable();
    this.router.navigate(['/admin-panel/generated-rate-list']);
  }

  openPrintView(ids: string) {
    window.open(`/rate-list/print/${ids}`, '_blank');
  }
}